import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=a811e8ca&scoped=true"
import script from "./DidYouKnow.vue?vue&type=script&lang=js"
export * from "./DidYouKnow.vue?vue&type=script&lang=js"
import style0 from "./DidYouKnow.vue?vue&type=style&index=0&id=a811e8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a811e8ca",
  null
  
)

export default component.exports